module.exports = __webpack_public_path__ + "static/img/aboutUsd.1e0c814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUsd.png
// module id = db2+
// module chunks = 1